import axios from 'axios'

export default {
    // Categories
    getCategoryList() {
        return axios.get('/api/v1/ipanel/pricelist-categories/')
    },
    createCategory(data) {
        return axios.post('/api/v1/ipanel/pricelist-categories/', data)
    },
    updateCategory(id, data) {
        return axios.patch(`/api/v1/ipanel/pricelist-categories/${id}/`, data)
    },
    deleteCategory(id) {
        return axios.delete(`/api/v1/ipanel/pricelist-categories/${id}/`)
    },
    getCategoryDetail(id) {
        return axios.get(`/api/v1/ipanel/pricelist-categories/${id}/`)
    },

    // Photos
    getPhotoList(params) {
        return axios.get('/api/v1/ipanel/pricelist-photos/', { params })
    },
    createPhoto(data) {
        return axios.post('/api/v1/ipanel/pricelist-photos/', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },
    updatePhoto(id, data) {
        return axios.patch(`/api/v1/ipanel/pricelist-photos/${id}/`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },
    deletePhoto(id) {
        return axios.delete(`/api/v1/ipanel/pricelist-photos/${id}/`)
    },
    getPhotoDetail(id) {
        return axios.get(`/api/v1/ipanel/pricelist-photos/${id}/`)
    }
}
